<template>
  <v-navigation-drawer
    app
    :temporary="isSmall"
    :permanent="!isSmall"
    :expand-on-hover="!isSmall"
    :mini-variant.sync="mini"
    v-model="localValue"
    width="320"
    class="parent-list-overflow"
  >
    <div class="list-overflow">
      <v-list-item class="pl-2">
        <v-avatar color="orange" size="40" class="mr-2">
          <v-img src="../../assets/default-user.png"/>
        </v-avatar>
        <v-list-item-content>
          <v-list-item-title class="title">
            <strong v-if="user">{{ user.nome }}</strong>
          </v-list-item-title>
          <v-list-item-subtitle>
            Bem-vindo!
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider/>
      <!-- Indicadores -->
      <v-list dense>
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
          v-model="expandIndicadores">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-chart-areaspline</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">Indicadores</v-list-item-title>
          </template>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasRoleComprador && !hasModuleGestorFrete
            && !hasRoleRequisicao && !hasRoleAprovador
            && !hasRoleAprovadorRequisicao && !hasRoleGestorCompras"
            to="/meu-painel"
          >
            <v-list-item-icon>
              <v-icon>mdi-monitor-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Meu painel</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :disabled="!hasRoleComprador && !hasRoleAprovadorRequisicao
            && !hasRoleAprovador && !hasRoleGestorCompras"
            :class="groupItemClass"
            to="/dashboard">
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- To do liberar acesso quando testes de indicadores metabase tiverem finalizados -->
          <v-list-item
            v-if="false"
            link
            active-class="orange--text"
            :disabled="!hasRoleComprador && !hasModuleGestorFrete
            && !hasRoleRequisicao && !hasRoleAprovador
            && !hasRoleAprovadorRequisicao && !hasRoleGestorCompras"
            to="/metabase/dashboard">
            <v-list-item-icon>
              <v-icon>mdi-chart-bar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Indicadores
                <v-chip label x-small class="secondary ml-3">Novo</v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :disabled="!hasRoleComprador && !hasRoleAprovadorRequisicao
            && !hasRoleAprovador && !hasRoleGestorCompras"
            :class="groupItemClass"
            to="/indicadores-compras"
          >
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Indicadores de compras</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            v-if="hasModuleGestorFrete && !hasRoleAprovadorRequisicao
            && !hasRoleAprovador && !hasRoleGestorCompras"
            :class="groupItemClass"
            to="/dashboard-frete"
          >
            <v-list-item-icon>
              <v-icon>mdi-truck-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Indicadores de frete</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasRoleComprador && !hasRoleAprovadorRequisicao
            && !hasRoleAprovador && !hasRoleGestorCompras"
            to="/indicador-fornecedores"
          >
            <v-list-item-icon>
              <v-icon>mdi-factory</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Fornecedores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <!-- Gestão de Compras -->
      <v-list dense>
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
          v-model="expandGestaoCompras">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-shopping-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">
              Gestão de compras
            </v-list-item-title>
          </template>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasRoleComprador && !hasRoleRequisicao
            && !hasRoleGestorCompras"
            to="/requisicoes"
          >
            <v-list-item-icon>
              <v-icon>mdi-package-up</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Solicitações de compra</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasRoleAprovadorRequisicao&& !hasRoleRequisicao
            && !hasRoleGestorCompras && !hasRoleComprador"
            to="/aprovacoes-solicitacoes"
          >
            <v-list-item-icon>
              <v-icon>mdi-package-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Aprovações de solicitações
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasRoleComprador && !hasRoleGestorCompras"
            to="/cotacoes"
          >
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Cotações</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasRoleAprovador && !hasRoleComprador
            && !hasRoleGestorCompras"
            active-class="orange--text"
            to="/aprovacoes-compras"
          >
            <v-list-item-icon>
              <v-icon>mdi-check-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Aprovações de compra</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasRoleComprador && !hasRoleAprovador
            && !hasRoleGestorCompras"
            active-class="orange--text"
            to="/compras"
          >
            <v-list-item-icon>
              <v-icon>mdi-shopping</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Compras</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="hasControleEntrega || hasRoleGestorCompras"
            link
            :class="groupItemClass"
            :disabled="!hasRoleGestorEntrega && !hasRoleGestorCompras"
            active-class="orange--text"
            to="/gesta-entregas">
            <v-list-item-icon>
              <v-icon>mdi-truck</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Entregas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <!-- Gestão de Frete -->
      <v-list dense v-if="hasModuleGestorFrete">
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
          v-model="expandGestaoFrete"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-truck</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">
              Gestão de frete
            </v-list-item-title>
          </template>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGestorFrete"
            to="/cotacoes-fretes"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-truck-fast</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Cotações de fretes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasModuleGestorFrete"
            :class="groupItemClass"
            to="/contratacoes-fretes"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-truck-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Contratações de fretes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <!-- Cadastros gerais da plataforma -->
      <v-list dense >
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
          v-model="expandCadastros"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-package-variant-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">
              Cadastros
            </v-list-item-title>
          </template>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras && !hasRoleComprador"
            :class="groupItemClass"
            to="/fornecedores"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-check-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Fornecedores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras && !hasRoleCadastroProduto"
            :class="groupItemClass"
            to="/categorias"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-view-grid</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Categorias</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras && !hasRoleCadastroProduto"
            :class="groupItemClass"
            to="/produtos"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-package-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Meus produtos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras && !hasRoleCadastroProduto"
            :class="groupItemClass"
            to="/unidades-medidas"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-beaker-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Unidades de Medida</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras"
            :class="groupItemClass"
            to="/modos-pagamento"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-cash-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Modos de pagamento</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras"
            :class="groupItemClass"
            to="/centros-custo"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-puzzle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Centros de custo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="(!hasRoleGestorCompras)"
            :class="groupItemClass"
            to="/projetos"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-folder-table-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Projetos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasRoleComprador && !hasRoleGestorCompras"
            to="/locais-entrega"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Locais de entrega</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras"
            :class="groupItemClass"
            to="/tabelas-preco"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-table</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Tabelas de preço</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras"
            :class="groupItemClass"
            to="/configuracoes-nota-entrada"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-invoice-list-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Notas de Entrada</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras"
            :class="groupItemClass"
            to="/mensagens"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-message-text-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Mensagens personalizadas
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <!-- Configurações da entidade -->
      <v-list dense >
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
          v-model="expandConfiguracoes"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-cogs</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">
              Configurações
            </v-list-item-title>
          </template>
          <v-list-item
            link
            to="/minha-empresa"
            :class="groupItemClass"
            active-class="orange--text">
            <v-list-item-icon>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Minha empresa</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras && !hasRoleConfiguradorAlcadaCompra"
            :class="groupItemClass"
            to="/alcadas-compra"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-tune</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Alçadas de compra</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras && !hasRoleConfiguradorAlcadaRequisicao"
            :class="groupItemClass"
            to="/alcadas-solicitacao"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-tune</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Alçadas de solicitação</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasRoleGestorCompras"
            :class="groupItemClass"
            to="/configuracoes-moedas"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Moedas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasIntegracaoAtiva || (!hasRoleComprador && !hasRoleGestorCompras)"
            :class="groupItemClass"
            to="/integracao"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-connection</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Integração</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['value'],
  data() {
    return {
      mini: true,
      expandIndicadores: false,
      expandCadastros: false,
      expandGestaoCompras: false,
      expandConfiguracoes: false,
      expandGestaoFrete: false,
    };
  },
  computed: {
    ...mapGetters('user', ['user', 'hasRoleComprador', 'hasModuleGestorFrete', 'hasRoleRequisicao', 'hasRoleAprovador', 'hasRoleGestorCompras', 'hasRoleGestorEntrega', 'hasRoleCadastroProduto', 'hasRoleAprovadorRequisicao', 'hasRoleConfiguradorAlcadaRequisicao', 'hasRoleConfiguradorAlcadaCompra']),
    ...mapGetters('entidade', ['hasControleEntrega', 'hasIntegracaoAtiva']),
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    groupItemClass() {
      return this.mini ? '' : 'group-item';
    },
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    miniComputed: {
      get() {
        return this.isSmall;
      },
    },
  },
  methods: {
    openMarketplace() {
      window.open(`${this.marketplaceUrl}`, '_blank');
    },
  },
  created() {
    if (this.isSmall) {
      this.mini = false;
    }
  },
};
</script>

<style scoped>
.group-item {
  padding-left: 30px !important;
}

.parent-list-overflow {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.list-overflow {
  width: 100%;
  height: 100%;
  padding-right: 17px;
  overflow-y: scroll;
  box-sizing: content-box;
}
</style>
